import React, { useContext } from "react";
import Logo from "../../assets/logo.png";
import "../../styles/footer.css";
import { WebsiteContext } from "../../context/AppContext";
import { motion } from "framer-motion";
import {
  FaFacebookF,
  FaInstagram,
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

const FooterComponent = () => {
  const { color, dark, handleRoute, isMobileView } = useContext(WebsiteContext);

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 70,
        damping: 15,
      },
    },
  };

  return (
    <div className={!dark ? "footer_wrapper_light" : "footer_wrapper_dark"}>
      <motion.div
        className="footer_grid_container"
        variants={containerVariants}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
      >
        {/* Column 1: Brand Info */}
        <motion.div className="footer_col brand_col" variants={itemVariants}>
          <div
            className="footer_brand_header"
            onClick={() => handleRoute("Home")}
          >
            <img
              src={Logo}
              alt="SSS Covai Travels Logo"
              className="footer_logo"
            />
            <h2 className="footer_brand_title" style={{ color: color }}>
              SSS COVAI TRAVEL'S
            </h2>
          </div>
          <p className="footer_brand_description" style={{ color: color }}>
            Premium, affordable, and comfortable rides anytime, anywhere. Your
            trusted travel partner in South India.
          </p>
          <div className="footer_socials">
            <a
              href="https://wa.me/919655590136"
              target="_blank"
              rel="noreferrer"
              className="social_icon_link"
            >
              <FaWhatsapp className="social_icon whatsapp" />
            </a>
            <a href="#" className="social_icon_link">
              <FaFacebookF className="social_icon facebook" />
            </a>
            <a href="#" className="social_icon_link">
              <FaInstagram className="social_icon instagram" />
            </a>
          </div>
        </motion.div>

        {/* Column 2: Quick Links */}
        <motion.div className="footer_col links_col" variants={itemVariants}>
          <h3 className="footer_col_title" style={{ color: color }}>
            Quick Links
          </h3>
          <ul className="footer_links_list">
            <li onClick={() => handleRoute("Home")} style={{ color: color }}>
              Home
            </li>
            <li onClick={() => handleRoute("blog")} style={{ color: color }}>
              Blog
            </li>
            <li
              onClick={() => handleRoute("Privacy_policy")}
              style={{ color: color }}
            >
              Privacy Policy
            </li>
            <li
              onClick={() => handleRoute("Terms_of_service")}
              style={{ color: color }}
            >
              Terms of Service
            </li>
          </ul>
        </motion.div>

        {/* Column 3: Contact Info */}
        <motion.div className="footer_col contact_col" variants={itemVariants}>
          <h3 className="footer_col_title" style={{ color: color }}>
            Contact Us
          </h3>
          <div className="footer_contact_item" style={{ color: color }}>
            <FaPhoneAlt className="contact_icon" />
            <span>+91 96555 90136</span>
          </div>
          <div className="footer_contact_item" style={{ color: color }}>
            <FaEnvelope className="contact_icon" />
            <span>info@ssscovaitravels.com</span>
          </div>
          <div className="footer_contact_item" style={{ color: color }}>
            <FaMapMarkerAlt className="contact_icon" />
            <span>Coimbatore, Tamil Nadu, India</span>
          </div>
        </motion.div>
      </motion.div>

      {/* Bottom Bar */}
      <motion.div
        className="footer_bottom_bar"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.5, duration: 0.5 }}
      >
        <div className="bar_line"></div>
        <div className="footer_bottom_content">
          <p className="footer_copy_rights" style={{ color: color }}>
            &copy; {new Date().getFullYear()} SSS Covai Travels. All Rights
            Reserved.
          </p>
          <p className="footer_slogan" style={{ color: color }}>
            Small Step 🤏 - Big Change ✌️
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default FooterComponent;
